
import React from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Badge,
} from "reactstrap";

import { useAuth } from "context/AuthContext";
import { useSede } from "context/SedeContext";
import { useNavigate } from "react-router-dom";


function AdminNavbar(props) {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [color, setColor] = React.useState("navbar-transparent");
  const location = useLocation();
  const { logout } = useAuth();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { 
    selectedSedes, 
    availableSedes, 
    loading: sedesLoading,
    error: sedesError,
    updateSelectedSedes, 
    selectGlobal, 
    selectAllSedes,
    getSelectionText 
  } = useSede();

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
  });
  React.useEffect(() => {
    if (
      window.outerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }, [location]);
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setSidebarOpen(!sidebarOpen);
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  const toggleCollapse = () => {
    if (!collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
    setCollapseOpen(!collapseOpen);
  };
  return (
    <>
      <Navbar
        className={classnames("navbar-absolute fixed-top", color)}
        expand="lg"
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize">
              <Button
                className="btn-icon btn-round"
                color="default"
                id="minimizeSidebar"
                onClick={props.handleMiniClick}
              >
                <i className="nc-icon nc-minimal-right text-center visible-on-sidebar-mini" />
                <i className="nc-icon nc-minimal-left text-center visible-on-sidebar-regular" />
              </Button>
            </div>
            <div
              className={classnames("navbar-toggle", {
                toggled: sidebarOpen,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
              <span className="d-none d-md-block">
                Revive Pilates Studio - Admin
              </span>
              <span className="d-block d-md-none">Revive - Admin</span>
            </NavbarBrand>
          </div>
          <button
            aria-controls="navigation-index"
            aria-expanded={collapseOpen}
            aria-label="Toggle navigation"
            className="navbar-toggler"
            // data-target="#navigation"
            data-toggle="collapse"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse
            className="justify-content-end"
            navbar
            isOpen={collapseOpen}
          >
            {/* <Form>
              <InputGroup className="no-border">
                <Input defaultValue="" placeholder="Search..." type="text" />
                <InputGroupAddon addonType="append">
                  <InputGroupText>
                    <i className="nc-icon nc-zoom-split" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Form> */}
            <Nav navbar>
              {/* Selector de Sede - Solo para Admins */}
              {user?.groups?.includes('admin') && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret size="sm" className="px-2" disabled={sedesLoading}>
                    <i className="nc-icon nc-pin-3" />
                    <span className="d-none d-lg-inline ml-1" style={{ fontSize: '0.85rem' }}>
                      {sedesLoading ? 'Cargando...' :
                       sedesError ? 'Error' :
                       selectedSedes.length === 0 ? '🌐 Global' : 
                       selectedSedes.length === 1 ? selectedSedes[0].name : 
                       `${selectedSedes.length} sedes`}
                    </span>
                  </DropdownToggle>
                <DropdownMenu right style={{ minWidth: '200px' }}>
                  <DropdownItem header style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}>
                    <strong>Sede</strong>
                    {sedesLoading && <span className="ml-2 text-muted">(Cargando...)</span>}
                  </DropdownItem>
                  <DropdownItem divider style={{ margin: '0.25rem 0' }} />
                  
                  {sedesError ? (
                    <DropdownItem disabled style={{ fontSize: '0.8rem', padding: '0.4rem 1rem', color: 'red' }}>
                      ❌ Error al cargar sedes
                    </DropdownItem>
                  ) : (
                    <>
                  <DropdownItem onClick={selectGlobal} style={{ fontSize: '0.8rem', padding: '0.4rem 1rem' }}>
                    🌐 Todas las sedes
                    <small className="text-muted d-block">Ver datos combinados</small>
                  </DropdownItem>
                  
                  {availableSedes.length > 0 && (
                    <>
                      <DropdownItem divider style={{ margin: '0.25rem 0' }} />
                      <DropdownItem header style={{ fontSize: '0.7rem', padding: '0.3rem 1rem', color: '#6c757d' }}>
                        SEDES ESPECÍFICAS
                      </DropdownItem>
                      {availableSedes.map((sede) => (
                        <DropdownItem 
                          key={sede.id} 
                          onClick={() => updateSelectedSedes([sede])}
                          className={selectedSedes.some(s => s.id === sede.id) ? 'active' : ''}
                          style={{ fontSize: '0.8rem', padding: '0.4rem 1rem' }}
                        >
                          📍 {sede.name}
                          {selectedSedes.some(s => s.id === sede.id) && (
                            <Badge color="primary" size="sm" className="ml-1" style={{ fontSize: '0.6rem' }}>✓</Badge>
                          )}
                        </DropdownItem>
                      ))}
                    </>
                  )}
                  
                  <DropdownItem divider style={{ margin: '0.25rem 0' }} />
                  <DropdownItem 
                    onClick={() => {
                      localStorage.removeItem('selectedSedes');
                      window.location.reload();
                    }}
                    style={{ fontSize: '0.8rem', padding: '0.4rem 1rem', color: '#6c757d' }}
                  >
                    🔄 Cambiar sede
                  </DropdownItem>
                      
                      {availableSedes.length === 0 && !sedesLoading && (
                        <DropdownItem disabled style={{ fontSize: '0.8rem', padding: '0.4rem 1rem' }}>
                          No hay sedes disponibles
                        </DropdownItem>
                      )}
                    </>
                  )}
                </DropdownMenu>
                </UncontrolledDropdown>
              )}
              
              {/* Indicador de Sede para Usuarios No-Admin */}
              {!user?.groups?.includes('admin') && user?.sede && (
                <NavItem className="px-2">
                  <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                    <i className="nc-icon nc-pin-3" />
                    <span className="d-none d-lg-inline ml-1">
                      {user.sede.name}
                    </span>
                  </span>
                </NavItem>
              )}

              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <i className="nc-icon nc-settings-gear-65" />
                  <p className="d-lg-none d-md-block">Cuenta</p>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem disabled>
                    <strong>{user?.first_name || "Usuario"}</strong>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() => {
                      logout();
                      navigate("/auth/login");
                    }}
                  >
                    <i className="nc-icon nc-button-power" /> Cerrar sesión
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
